import clientSDK from '../../App/ClientSDK'

import { IAbsenceType, IAPIAbsenceType } from './IAbsenceType'

const absenceTypeTransformer = (data: IAPIAbsenceType): IAbsenceType => ({
  total: data.total,
  list: data.list.map(item => ({
    uuid: item.uuid,
    key: item.key,
    types: item.types.map(type => ({
      uuid: type.uuid,
      key: type.key,
      color: type.color,
      shouldBeCaughtUp: type.should_be_caught_up,
    })),
  })),
})

const baseUrl = 'hr/absences/types'

const getList = async () => {
  const response = await clientSDK.instance().get<IAPIAbsenceType>(baseUrl)
  const data = response.data
  return absenceTypeTransformer(data)
}

const useAbsenceTypeService = {
  getList,
}

export default useAbsenceTypeService
